import { useEffect, useState } from "react";
import "./View_selection.css";

export default function View_selection() {
  const [virtualTable, setVirtualTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  console.log("seleceted teams : ", selectedTeams);
  const [editingTeam, setEditingTeam] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [originalValue, setOriginalValue] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  const handleDoubleClick = (teamcode, field, value) => {
    setEditingTeam(teamcode);
    setEditingField(field);
    setOriginalValue(value);
  };

  const handleFieldChange = (teamcode, field, value) => {
    setVirtualTable((prev) =>
      prev.map((item) =>
        item.teamcode === teamcode
          ? {
            ...item,
            [field]: value,
          }
          : item,
      ),
    );
  };

  const finishEditing = () => {
    setEditingTeam(null);
    setEditingField(null);
    setOriginalValue(null);
  };

  const handleToggle = (teamcode) => {
    setSelectedTeams(
      (prev) =>
        prev.includes(teamcode)
          ? prev.filter((t) => t !== teamcode) // remove
          : [...prev, teamcode], // add
    );
  };

  const fetchVirtualTable = async () => {
    try {
      const res = await fetch(`${API_URL}/virtual_table/view`);
      const data = await res.json();
      setVirtualTable(data);
      console.log("virtual data ", data);
    } catch (err) {
      console.error("Error fetching virtual table:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVirtualTable();
  }, []);

  // ---- delete function
  const handleDelete = async (teamcode) => {
    try {
      const response = await fetch(
        `${API_URL}/remove_team/${teamcode}`,
        {
          method: "DELETE",
        },
      );

      const data = await response.json();
      console.log("Deleted:", data);

      // refresh virtual table after delete
      fetchVirtualTable();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  //  -------- selected  calculations  --------
  const selectedcalculationData = virtualTable.reduce(
    (acc, item) => {
      if (selectedTeams.includes(item.teamcode)) {
        acc.data[item.teamcode] = item;
        acc.count++;

        if (acc.default_stake === null) {
          acc.default_stake = item.default_stake;
        }
        acc.totalStakeIndividual += Number(item.individual_multiplier) || 0;
        acc.totalOdds *= item.odd;
        acc.expectedReturn += item.individual_multiplier * item.odd;
      }

      return acc;
    },
    {
      data: {},
      count: 0,
      default_stake: null,
      totalStakeIndividual: 0,
      totalOdds: 1,
      expectedReturn: 0,
    },
  );

  const SelectedTeamCount = selectedcalculationData.count;
  const stake = selectedcalculationData.default_stake;
  const [editedStake, setEditedStake] = useState(null);
  const [editingStake, setEditingStake] = useState(false);

  const currentStake = editedStake ?? stake;
  const singleStake = selectedcalculationData.totalStakeIndividual;
  const TotalOdds = selectedcalculationData.totalOdds.toFixed(2);
  const PotentialWin = (TotalOdds * currentStake).toFixed(2);
  const ExpectedReturn = selectedcalculationData.expectedReturn;
  const profitTake = ExpectedReturn - singleStake;
  const multipleProfit = PotentialWin - currentStake;

  const teams = Object.values(selectedcalculationData.data).sort(
    (a, b) => a.odd - b.odd,
  );
  console.log("teams data ", teams);
  const winners = [];
  const losers = [];

  teams.forEach((team, index) => {
    (index % 2 === 0 ? winners : losers).push(team);
  });

  const winningReturn = winners.reduce((total, team) => {
    return (total += team.Expected_return);
    // total + stake * team.odd;
  }, 0);

  console.log("teams_win", winners);
  console.log("teams_loss", losers);
  console.log("teams_return", winningReturn);

  const roiSingle = ((profitTake / singleStake) * 100).toFixed(2);

  const profitLoss = winningReturn - singleStake;
  const profitLossRoi = ((profitLoss / singleStake) * 100).toFixed(2);

  function createInstanceId(teamCode) {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const team = teamCode.substring(0, 3).toUpperCase();

    const random3 = Math.floor(100 + Math.random() * 900);
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const random5 = Math.floor(10000 + Math.random() * 90000);

    return `${day}${month}_${year}_${team}_${random3}-${seconds}-${random5}`;
  }
  //  -------- selected team save function --------
  const handleSave = async () => {
    try {
      const instance_id = createInstanceId(selectedTeams[0] || "GEN");
      const selected_forwarding_data = selectedTeams.map((teamCode) => {
        const team = teams.find((t) => t.teamcode === teamCode);
        console.log("teams data --ma ", teams);

        return {
          teamCode,
          odds: team?.odd ?? 0,
          single_stake: team?.individual_multiplier ?? 0,
          instance_id: instance_id,
        };
      });

      const payload = {
        teams: selected_forwarding_data,
        instance: {
          instance_id: instance_id,
          total_odds_multiple: TotalOdds,
          total_stake_single: singleStake,
          multiple_stake: currentStake,
        },
      };
      console.log(JSON.stringify(payload, null, 2));

      const response = await fetch(
        `${API_URL}/save_virtual_table`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      console.log("Saved successfully:", data);
      alert("Teams saved successfully!");
    } catch (error) {
      console.error("Error saving teams:", error);
      alert("Failed to save teams.");
    }
  };
  //  -------- selected team save function --------
  const updateTeam = async (teamcode, changes) => {
    try {
      const response = await fetch(
        `${API_URL}/virtual/update_team`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            teamcode,
            ...changes,
          }),
        },
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || "Failed to update team");
      }

      const data = await response.json();

      // FastAPI has recalculated Expected_return and ROI
      setVirtualTable(data.virtual_table);
    } catch (error) {
      console.error("Update team error:", error);
    }
  };

  // ---- end ::: save function ----

  if (loading) {
    return <p>Loading selections...</p>;
  }

  if (virtualTable.length === 0) {
    return <p>No selected teams yet</p>;
  }
  return (
    <>
      <div className="alg1_card">
        {/* start ------  */}
        <div className="virtual-table">
          {/* Circular Counter */}
          <div className="teams-counter">
            <div className="counter-circle">
              <span className="counter-number">{virtualTable.length}</span>
            </div>
            <span className="counter-label">
              {virtualTable.length === 1 ? "Match" : "Matches"} Selected
            </span>
          </div>
          <div className="table-container_num">
            <table>
              <thead>
                <tr>
                  <th>Team_code</th>
                  <th>Home Team</th>
                  <th>Away Team</th>
                  <th>League</th>
                  <th>Scheduled</th>
                  <th>Prediction</th>
                  <th>stake</th>
                  <th>Odds</th>
                  <th>Exp_rtn</th>
                  <th>ROI</th>
                  <th>Status</th>
                  <th>Action</th> {/* New column for button */}
                </tr>
              </thead>

              <tbody>
                {virtualTable.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      selectedTeams.includes(item.teamcode) ? "selected" : ""
                    }
                  >
                    <td>{item.teamcode}</td>
                    <td>{item.hometeam}</td>
                    <td>{item.awayteam}</td>
                    <td>{item.League}</td>
                    <td>
                      {new Date(item.time).toLocaleString([], {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>
                    <td>{item?.prediction}</td>
                    <td
                      className="editable-odd"
                      onDoubleClick={() =>
                        handleDoubleClick(
                          item.teamcode,
                          "individual_multiplier",
                          item.individual_multiplier,
                        )
                      }
                    >
                      {editingTeam === item.teamcode &&
                        editingField === "individual_multiplier" ? (
                        <input
                          type="number"
                          min="0"
                          step="100"
                          autoFocus
                          value={item.individual_multiplier}
                          onChange={(e) =>
                            handleFieldChange(
                              item.teamcode,
                              "individual_multiplier",
                              e.target.value,
                            )
                          }
                          onBlur={finishEditing}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              updateTeam(item.teamcode, {
                                multiplier: parseInt(
                                  item.individual_multiplier,
                                  10,
                                ),
                              });

                              finishEditing();
                            }

                            if (e.key === "Escape") {
                              setVirtualTable((prev) =>
                                prev.map((row) =>
                                  row.teamcode === item.teamcode
                                    ? {
                                      ...row,
                                      individual_multiplier: originalValue,
                                    }
                                    : row,
                                ),
                              );

                              finishEditing();
                            }
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      ) : (
                        item?.individual_multiplier
                      )}
                    </td>
                    <td
                      className="editable-odd"
                      onDoubleClick={() =>
                        handleDoubleClick(item.teamcode, "odd", item.odd)
                      }
                    >
                      {editingTeam === item.teamcode &&
                        editingField === "odd" ? (
                        <input
                          type="number"
                          step="0.01"
                          min="1"
                          autoFocus
                          value={item.odd}
                          onChange={(e) =>
                            handleFieldChange(
                              item.teamcode,
                              "odd",
                              e.target.value,
                            )
                          }
                          onBlur={finishEditing}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              updateTeam(item.teamcode, {
                                odd: parseFloat(item.odd),
                              });

                              finishEditing();
                            }

                            if (e.key === "Escape") {
                              setVirtualTable((prev) =>
                                prev.map((row) =>
                                  row.teamcode === item.teamcode
                                    ? {
                                      ...row,
                                      odd: originalValue,
                                    }
                                    : row,
                                ),
                              );

                              finishEditing();
                            }
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      ) : (
                        item?.odd
                      )}
                    </td>

                    <td>{item?.Expected_return}</td>
                    <td placeholder="Percentage">{item?.ROI}%</td>
                    <td>
                      <input
                        type="checkbox"
                        className="toggle-slider"
                        checked={selectedTeams.includes(item.teamcode)}
                        onChange={() => handleToggle(item.teamcode)}
                      />
                    </td>
                    <td>
                      <button
                        type="submit"
                        className="remove-btn"
                        onClick={() => handleDelete(item.teamcode)}
                        aria-label="Remove this match"
                      >
                        ×
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>

              <style>{`
                  .selected {
                    background: linear-gradient(90deg, #d4f8d4, #b9f6ca);
                    color: #0b3d0b;
                    font-weight: 600;
                    border-top: 1px solid #34c759;
                    border-bottom: 1px solid #34c759;
                    transition: all 0.25s ease;
                  }
                `}</style>
            </table>
          </div>
          <div>
            {selectedTeams?.length > 0 && (
              <div className="bet-grid">
                {/*----------- Multiple Bet  ------------------------ */}
                <div className="bet-card">
                  <h2 className="multiple-title">
                    Multiple Bet
                    <span className="bet-count">{SelectedTeamCount}</span>
                  </h2>

                  <div className="stat-card">
                    <span>Total Stake</span>

                    {editingStake ? (
                      <input
                        type="number"
                        min="0"
                        step="100"
                        autoFocus
                        value={editedStake ?? stake}
                        onChange={(e) => setEditedStake(Number(e.target.value))}
                        onBlur={() => setEditingStake(false)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setEditingStake(false);
                          }

                          if (e.key === "Escape") {
                            setEditedStake(null);
                            setEditingStake(false);
                          }
                        }}
                      />
                    ) : (
                      <strong onDoubleClick={() => setEditingStake(true)}>
                        Ksh {currentStake}
                      </strong>
                    )}
                  </div>

                  <div className="stat-card">
                    <span>Total Odds</span>
                    <strong>{TotalOdds}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Potential Win</span>
                    <strong>ksh {PotentialWin}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Profit</span>
                    <strong>ksh {multipleProfit}</strong>
                  </div>
                </div>
                {/*----------- Single Bet------------------------ */}
                <div className="bet-card">
                  <h2 className="single-title">Single Bet</h2>

                  <div className="stat-card">
                    <span>Total Stake</span>
                    <strong>ksh {singleStake}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Expected Return</span>
                    <strong>Ksh {ExpectedReturn}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Profit</span>
                    <strong>{profitTake}</strong>
                  </div>
                  <div className="stat-card">
                    <span>ROI</span>
                    <strong>{roiSingle} %</strong>
                  </div>
                </div>
                {/*----------- Risk management ------------------------ */}
                <div
                  className={`bet-card ${profitLossRoi > 0 ? "positive-roi" : "negative-roi"}`}
                >
                  <h2 className="single-title">Risk Management</h2>

                  <div className="stat-card">
                    <span>Total Stake</span>
                    <strong>ksh {singleStake}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Expected Return</span>
                    <strong>Ksh {winningReturn}</strong>
                  </div>

                  <div className="stat-card">
                    <span>Profit/Loss</span>
                    <strong>{profitLoss}</strong>
                  </div>

                  <div className="stat-card">
                    <span>ROI</span>
                    <strong>{profitLossRoi} %</strong>
                  </div>
                </div>
                <div className="bet-card save-card">
                  <button onClick={handleSave}>Save Selected Teams</button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* End ------  */}
      </div>
    </>
  );
}
